// 授权逻辑
import { getMemberId } from "./user";
import { loginPage } from "./dom";
import { Toast } from "@utils/page";
import { sleep } from "../public/utils";

/**
 * http://pdcbbs.tcent.cn/tools.html
 * app授权
 */
export async function getAuth() {
    await sleep(1000);
    // 获取openid
    let memberInfo = await getMemberId();
    // 不存在memberid
    if (!memberInfo.memberId) {
        // 跳转登陆页面
        memberInfo = await loginPage(true);
        console.log("登陆成功");
        Toast("登陆成功");
    }
    const { memberId: code, headImg: avatar, userName: nick } = memberInfo;
    return {
        userInfo: {
            code,
            avatar,
            nick
        }
    };
}
